// extracted by mini-css-extract-plugin
export default {"maxWidthInPc":"450px","diceContainer":"style_diceContainer__zzm6c"};